import React, { useCallback } from 'react'
import { Toggle } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '@fs/zion-analytics'
import { useContrastMode } from '../../../ContrastModeProvider'

export default function ContrastMode(): JSX.Element {
  const [t] = useTranslation()
  const { isHighContrast, setHighContrast } = useContrastMode()

  const onChange = useCallback((): void => {
    trackEvent({ link_name: `Toggled Contrast Mode to ${!isHighContrast}: Toggle` })
    setHighContrast(!isHighContrast)
  }, [isHighContrast, setHighContrast])

  return (
    <Toggle
      data-testid="contrast-mode-toggle"
      label={t('tree-person.high-contrast-mode.heading')}
      checked={isHighContrast}
      onChange={onChange}
    />
  )
}
